import React from "react";
import { DrivingCguChart } from "../../../charts";
import NoDrivingEvents from "./NoDrivingEvents";
import PropTypes from "prop-types";

const DrivingGroupCgu = ({ data, cguLimit, lang }) => {
  let componentToRender;
  let hasEvents = false;

  data.forEach(unidad => {
    if (unidad.Puntos > 0) {
      hasEvents = true;
    }
  });

  if (hasEvents) {
    componentToRender = (
      <DrivingCguChart data={data} cguLimit={cguLimit} lang={lang} />
    );
  } else {
    componentToRender = <NoDrivingEvents lang={lang} />;
  }

  return componentToRender;
};

DrivingGroupCgu.propTypes = {
  data: PropTypes.array.isRequired,
  lang: PropTypes.object.isRequired
};

export default DrivingGroupCgu;



// WEBPACK FOOTER //
// ./src/containers/Driving/DrivingEventVisualizations/DrivingGroupCgu.js